module.exports = __webpack_public_path__ + "static/media/list.c9609a18.png";